<template>
  <div>
    <breadcrumb/>
    <PostList :style="getZoomByScreen()" />
  </div>
</template>

<script>
import PostList from "@/components/Posts/PostList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    PostList,
    Breadcrumb
  },
  methods: {
    getZoomByScreen() {
      if (window.innerWidth <= 1366 && window.innerWidth >= 960)
        return "margin-bottom: -300px;";
    }
  },
};
</script>